/* HALDEN motion layer: cards rise in one after another as their row scrolls in,
   photos drift slightly slower than the page. Transforms and opacity only;
   nothing on the first screen, nothing with reduced motion or Animations off. */
(() => {
  const root = document.documentElement;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || root.classList.contains('no-fade') || !('IntersectionObserver' in window)) return;
  const ITEMS = '.how__card, .story__card, .rw__card, .reel, .accordion, .cmp__row, .guar__list > li, .product-card, .pswitch__item, .stx__stat';
  const init = () => {
    const fold = innerHeight * 0.9;
    const groups = new Map();
    document.querySelectorAll(ITEMS).forEach((el) => {
      if (el.closest('[data-fade]') || el.getBoundingClientRect().top < fold) return;
      const g = groups.get(el.parentElement) || [];
      g.push(el);
      groups.set(el.parentElement, g);
    });
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      (groups.get(e.target) || []).forEach((el, i) => {
        el.style.transitionDelay = Math.min(i, 6) * 90 + 'ms';
        el.classList.add('hm-in');
        setTimeout(() => (el.style.transitionDelay = ''), 1400 + i * 90);
      });
    }), { rootMargin: '0px 0px -12% 0px' });
    groups.forEach((items, parent) => {
      items.forEach((el) => el.classList.add('hm'));
      groups.set(parent, items);
      io.observe(parent);
    });
    /* photos drift: a few px of parallax inside their frames */
    const drift = [...document.querySelectorAll('.story__media img, .how__media img, .stg__bg, .rw__img img, .reel__media img')];
    if (!drift.length) return;
    let raf = 0;
    const tick = () => {
      raf = 0;
      const vh = innerHeight;
      drift.forEach((img) => {
        const r = img.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const p = (r.top + r.height / 2 - vh / 2) / vh;
        img.style.translate = `0 ${(p * -14).toFixed(1)}px`;
      });
    };
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });
    tick();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* artwork protection on mascots */
document.addEventListener('contextmenu', (e) => { if (e.target.closest('.mac, .hwx__stage')) e.preventDefault(); });
document.addEventListener('dragstart', (e) => { if (e.target.closest('.mac, .hwx__stage')) e.preventDefault(); });
